module.exports = __webpack_public_path__ + "logo.60f55c357ea24aabcb7f8adff0cb3492.png";